/* eslint-disable no-unused-vars */

import Vue from 'vue'
import { configure, extend, localize, ValidationProvider } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import cs from './cs'

export default () => {
  const config = {
    useConstraintAttrs: false, // disable inferred of HTML5 validations
    validity: false // disable HTML5 validations
  }

  // Sets the options.
  configure(config)

  // Register it globally
  Vue.component('ValidationProvider', ValidationProvider)

  extend('max', rules.max)
  extend('min', rules.min)
  extend('required', rules.required)

  localize('cs', cs as any)
}
